<script setup>
import {useRouter} from "vue-router";
import {onMounted, ref} from "vue";
import {useI18n} from "vue-i18n";
import createApiService from "@/services/api.js";
import PushNotificationBanner from "@/components/notifications/PushNotificationBanner.vue";

definePage({
  meta: {
    layout: 'minimal',
  },
});

const router = useRouter();
const {t} = useI18n();
const api = createApiService(router);
const projects = ref([]);
const loading = ref(false);

onMounted(() => {
  updateProjects();
});

const updateProjects = async () => {
  loading.value = true;
  try {
    const response = await api.get("materialCheckProjects");
    projects.value = response.data.data;
  } catch (error) {
    console.log(error?.response?.data?.data ?? error);
  } finally {
    loading.value = false;
  }
};
</script>

<template>
  <v-card-title>
    {{ t("material.page.title") }}
    <v-icon icon="mdi-refresh" size="small" color="primary" @click="updateProjects" :disabled="loading" />
  </v-card-title>
  <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-4" />

  <push-notification-banner />

  <v-card-text v-if="!loading && projects.length === 0" class="text-subtitle-1">
    {{ t("material.page.noProjects") }}
  </v-card-text>

  <template v-for="project in projects" :key="project.id">
    <v-card class="mb-4">
      <v-card-title>
        {{ project.name }}
      </v-card-title>
      <v-card-text>
        {{ project.address }}
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="project?.material_check === null"
          variant="elevated"
          color="primary"
          :to="{ name: '/material/project/[id]', params: { id: project.id } }"
        >
          {{ t("material.list.startInspection") }}
        </v-btn>
        <v-btn
          v-else
          color="grey"
          variant="elevated"
          disabled
        >
          {{ t("material.list.inspectionDone") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </template>
</template>

<style scoped>

</style>
